import { MessageCircle, Phone, MapPin } from "lucide-react";
import { LogoFull } from "./Logo";
import { WHATSAPP_LINK, PHONE_DISPLAY, PHONE_LINK, scrollToId } from "@/lib/site";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Homes & Business", href: "#audiences" },
  { label: "Service Area", href: "#area" },
  { label: "How It Works", href: "#how" },
  { label: "Free Quote", href: "#quote" },
];

export default function Footer() {
  return (
    <footer className="bg-[#1C3B2B] pb-10 pt-16 text-[#E2EFEA]">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col justify-between gap-10 border-b border-[#FBF9F5]/10 pb-12 lg:flex-row">
          <div className="max-w-sm">
            <LogoFull dark />
            <p className="mt-5 text-sm leading-relaxed text-[#E2EFEA]/70">
              Precision cleaning, windows, gardening, painting and repairs — for private homes and
              businesses across Shanzu &amp; Mombasa's North Coast.
            </p>
            <p className="mt-5 flex items-center gap-2 text-sm text-[#E2EFEA]/70">
              <MapPin size={15} className="text-[#D4A359]" /> Shanzu, Mombasa, Kenya
            </p>
          </div>

          <div>
            <p className="font-jbm text-[11px] font-semibold uppercase tracking-[0.25em] text-[#D4A359]">Explore</p>
            <ul className="mt-4 space-y-3">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    onClick={() => scrollToId(l.href)}
                    className="text-sm text-[#E2EFEA]/80 transition-colors duration-300 hover:text-[#FBF9F5]"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-jbm text-[11px] font-semibold uppercase tracking-[0.25em] text-[#D4A359]">Talk to us</p>
            <div className="mt-4 space-y-3">
              <a
                data-testid="footer-whatsapp-button"
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-3 text-sm font-semibold text-white transition-[background-color,transform] duration-300 hover:bg-[#20BA5A] hover:scale-[1.03]"
              >
                <MessageCircle size={16} /> WhatsApp {PHONE_DISPLAY}
              </a>
              <a
                data-testid="footer-call-button"
                href={PHONE_LINK}
                className="flex items-center gap-2 rounded-full border border-[#FBF9F5]/25 px-5 py-3 text-sm font-semibold text-[#FBF9F5] transition-colors duration-300 hover:bg-[#FBF9F5]/10"
              >
                <Phone size={16} /> Call {PHONE_DISPLAY}
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 pt-8 text-xs text-[#E2EFEA]/50">
          <p>© 2026 KeDe-Ceaning · Shanzu, Mombasa · All rights reserved</p>
          <a data-testid="footer-admin-link" href="/admin" className="underline-offset-4 transition-colors hover:text-[#FBF9F5] hover:underline">
            Owner Login
          </a>
        </div>
      </div>
    </footer>
  );
}
